var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "oss-upload-container" },
    [
      _vm.uploadType === "image"
        ? [
            !_vm.disabled && _vm.fileList.length < _vm.limit
              ? _c(
                  "div",
                  {
                    staticClass: "oss-upload-trigger",
                    on: { click: _vm.triggerFileInput },
                  },
                  [
                    _c("div", { staticClass: "oss-upload-trigger-inner" }, [
                      _c("i", { staticClass: "el-icon-plus" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "oss-upload-tip" }, [
                        _vm._v(
                          _vm._s(
                            _vm.drag ? "拖拽文件到此处或点击上传" : "点击上传"
                          )
                        ),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("input", {
              ref: "fileInput",
              staticStyle: { display: "none" },
              attrs: {
                type: "file",
                accept: _vm.acceptStr,
                multiple: _vm.multiple,
              },
              on: { change: _vm.handleNativeFileChange },
            }),
            _vm._v(" "),
            _vm.fileList.length > 0
              ? _c(
                  "div",
                  { staticClass: "oss-image-list" },
                  _vm._l(_vm.fileList, function (file, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "oss-image-item",
                        on: {
                          click: function ($event) {
                            return _vm.previewFile(file)
                          },
                        },
                      },
                      [
                        file.url
                          ? _c("img", {
                              staticClass: "oss-image-thumb",
                              attrs: { src: file.url, alt: "" },
                              on: {
                                error: function ($event) {
                                  return _vm.onImageError($event, index)
                                },
                              },
                            })
                          : file._uploading
                          ? _c(
                              "div",
                              { staticClass: "oss-image-placeholder" },
                              [
                                _c("el-progress", {
                                  attrs: {
                                    percentage: file._percent,
                                    type: "circle",
                                    width: 60,
                                  },
                                }),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              { staticClass: "oss-image-placeholder" },
                              [
                                _c("i", { staticClass: "el-icon-document" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "oss-image-name" }, [
                                  _vm._v(_vm._s(file.name)),
                                ]),
                              ]
                            ),
                        _vm._v(" "),
                        !_vm.disabled && !file._uploading
                          ? _c(
                              "span",
                              {
                                staticClass: "oss-image-delete",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.handleRemove(index)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "el-icon-delete" })]
                            )
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]
        : [
            !_vm.disabled
              ? _c(
                  "div",
                  {
                    staticClass: "upload-trigger-file",
                    on: { click: _vm.triggerFileInput },
                  },
                  [
                    _c("i", { staticClass: "el-icon-upload" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "upload-tip-file" },
                      [
                        _c("span", [_vm._v("拖拽文件到此处，或")]),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.triggerFileInput($event)
                              },
                            },
                          },
                          [_vm._v("点击选择文件")]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.tipText
                      ? _c("div", { staticClass: "upload-hint" }, [
                          _vm._v(_vm._s(_vm.tipText)),
                        ])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("input", {
              ref: "fileInput",
              staticStyle: { display: "none" },
              attrs: {
                type: "file",
                accept: _vm.acceptStr,
                multiple: _vm.multiple,
              },
              on: { change: _vm.handleNativeFileChange },
            }),
            _vm._v(" "),
            _vm.fileList.length > 0
              ? _c(
                  "div",
                  { staticClass: "file-list-panel" },
                  _vm._l(_vm.fileList, function (file, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "file-list-item" },
                      [
                        _c("i", { staticClass: "el-icon-document" }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "file-name",
                            on: {
                              click: function ($event) {
                                return _vm.previewFile(file)
                              },
                            },
                          },
                          [_vm._v(_vm._s(file.name))]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "file-size" }, [
                          _vm._v(_vm._s(_vm.formatFileSize(file.size))),
                        ]),
                        _vm._v(" "),
                        file._uploading
                          ? _c("el-progress", {
                              staticStyle: {
                                width: "150px",
                                "margin-left": "10px",
                              },
                              attrs: {
                                percentage: file._percent,
                                "stroke-width": 4,
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "file-actions" },
                          [
                            !file._uploading
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.previewFile(file)
                                      },
                                    },
                                  },
                                  [_vm._v("预览")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.disabled && !file._uploading
                              ? _c(
                                  "el-button",
                                  {
                                    staticStyle: { color: "#f56c6c" },
                                    attrs: { type: "text", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleRemove(index)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  0
                )
              : _vm._e(),
          ],
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.previewVisible,
            title: _vm.previewTitle,
            "append-to-body": "",
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewVisible = $event
            },
          },
        },
        [
          _vm.previewIsImage
            ? _c("img", {
                staticStyle: {
                  "max-width": "100%",
                  "max-height": "70vh",
                  display: "block",
                  margin: "0 auto",
                },
                attrs: { src: _vm.previewUrl, alt: "" },
              })
            : _c(
                "div",
                { staticStyle: { "text-align": "center", padding: "40px" } },
                [
                  _c("i", {
                    staticClass: "el-icon-document",
                    staticStyle: { "font-size": "64px", color: "#909399" },
                  }),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticStyle: { "margin-top": "16px", color: "#606266" } },
                    [_vm._v(_vm._s(_vm.previewTitle))]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.downloadFile(
                            _vm.previewUrl,
                            _vm.previewTitle
                          )
                        },
                      },
                    },
                    [_vm._v("下载文件")]
                  ),
                ],
                1
              ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }